import { TENANT_DB_NAME, TENANT_API_URL } from './tenant';

export const DB_NAME = TENANT_DB_NAME;
export const DB_VERSION = 104; // v104: attendanceCodes. v103: liftTruckPmInspections (Lift Truck PM Inspection drafts); v102 dev builds could upgrade before the store existed
export const EMPLOYEE_STORE = 'employees';
export const VENDOR_STORE = 'vendors';
export const TRUCK_STORE = 'trucks';
export const INSTRUCTION_STORE = 'instructions';
export const TOOLBOXTALK_STORE = 'toolboxtalks';
export const WEEKLY_INSTRUCTION_STORE = 'weeklyInstructions';
export const WEEK_LIST_STORE = 'weeklyList';
export const SIGNED_DOCS_STORE = 'signedDocuments';
export const TRAINING_DUE_STORE = 'trainingDue';
export const TRAINING_DUE_TEXT_STORE = 'trainingDueText';
export const TRAINING_DUE_FORM_STORE = 'trainingDueDefaultForm';
export const TRAINING_STORE = 'training';
export const MEP_FORM_STORE = 'trainingDueMepForm ';
export const FT_FORM_STORE = 'trainingDueFtForm';
export const WELDING_FORM_STORE = 'trainingDueWeldingForm';
export const COST_CODE_STORE = 'costCode';
export const GL_CODE_STORE = 'glCode';
export const CC_STORE = 'ccPhoto';
export const JOB_STORE = 'job';
export const ALT_JOB_STORE = 'altJob';
export const CODE_GROUP_STORE = 'codeGroup';
export const INI_STORE = 'ini';
export const SSD_STORE = 'ssd';
export const STATUS_NEW = 'new';
export const STATUS_PROCESS = 'process';
export const STATUS_FINISH = 'finish';
export const STATUS_SEND = 'send';
export const STATUS_DRAFT = 'draft';
export const STATUS_SUBMITTED = 'submitted';
export const USER_STORE = 'user';
export const JHA_STORE = 'jha';
export const ENERGY_STORE = 'energy';
export const CONDITIONS_STORE = 'conditions';
export const DOCS_PERMIT_STORE = 'docsPermit';
export const EVALUATION_OF_WORK_STORE = 'evaluationOfWork';
export const JOB_TASK_STORE = 'jobTask';
export const WORK_ACTIVITIES_STORE = 'workActivities';
export const TEMPS_STORE = 'temps';
export const ATTEND_CODES_STORE = 'attendanceCodes';
export const TEMP_AGENCY_STORE = 'tempAgency';
export const TEMP_EXHIBIT_B_STORE = 'tempExhibitB';
export const TRAINER_STORE = 'trainers';
export const DAILY_LOG_STORE = 'dailyLogs';
export const INCIDENT_STORE = 'incidents';
export const WITNESS_STORE = 'witness_statements';
export const UNIFIED_FORM_STORE = 'unifiedForms';
export const TBT_SUBMISSION_STORE = 'tbtSubmissions';
export const PIPE_HYDRO_TEST_STORE = 'pipeHydroTests';
export const VESSEL_HYDRO_TEST_STORE = 'vesselHydroTests';
export const SERVICE_LEAK_TEST_STORE = 'serviceLeakTests';
export const WELD_MAP_STORE = 'weldMaps';
export const PNEUMATIC_TEST_STORE = 'pneumaticTests';
export const TORQUE_MAP_STORE = 'torqueMaps';
export const GAS_LINE_INSPECTION_STORE = 'gasLineInspections';
export const MEGGER_TEST_STORE = 'meggerTests';
export const TERMINAL_TORQUE_TEST_STORE = 'terminalTorqueTests';
export const PANEL_SHOP_QC_STORE = 'panelShopQcChecklists';
export const JOB_SITE_SAFETY_INSPECTION_STORE = 'jobSiteSafetyInspections';
// Published question schemas, keyed by revision number. More than one is kept on purpose: a draft
// started on an older revision must keep rendering the questions it was actually filled out against.
export const JSSI_SCHEMA_STORE = 'jssiSchemas';
export const BUS_INSPECTION_STORE = 'busInspectionReports';
export const CABLE_WIRING_SCHEDULE_STORE = 'cableWiringSchedules';
export const ENERGIZED_WORK_PERMIT_STORE = 'energizedWorkPermits';
export const CHANGE_ORDER_STORE = 'changeOrders';
export const SOW_STORE = 'scopeOfWorks';
export const OPERATOR_PRACTICAL_EVALUATION_STORE = 'operatorPracticalEvaluations';
export const AERIAL_SCISSOR_LIFT_OPERATOR_STORE = 'aerialScissorLiftOperatorEvaluations';
export const SPOTTER_TRAINING_STORE = 'spotterTrainings';
export const PACKING_SLIP_STORE = 'packingSlips';
export const CSEP_STORE = 'confinedSpaceEntryPermits';
export const LTT_STORE = 'lockTagTryPermits';
export const CONTINUOUS_IMPROVEMENT_STORE = 'continuousImprovements';
export const WARRANTY_STORE = 'warranties';
export const EQUIPMENT_STORE = 'equipment';
export const EQUIP_LOCATION_STORE = 'equipLocations';
export const PURCHASE_ORDER_STORE = 'purchaseOrders';
export const PO_EDITS_STORE = 'poEdits';
export const PRACTICAL_EVALUATION_TYPE_STORE = 'practicalEvaluationTypes';
export const PRACTICAL_EVALUATION_STORE = 'practicalEvaluations';
export const TOOL_INVENTORY_STORE = 'toolInventory'; // legacy, VB6-synced (still used by Gas Monitor form)
export const TOOL_STORE = 'tools';                    // new, local Symfony Tool entity (SRD form)
export const TOOL_CALIBRATION_STORE = 'toolCalibration';
export const TOOL_DOCS_STORE = 'toolDocs';
export const TOOL_ASSIGNMENT_STORE = 'toolAssignments';
export const GAS_MONITOR_TEST_STORE = 'gasMonitorTests';
export const SRD_INSPECTION_STORE = 'srdInspections';
export const FALL_ARREST_RESCUE_PLAN_STORE = 'fallArrestRescuePlans';
export const WELDER_QUALIFICATION_RELEASE_STORE = 'welderQualificationReleases';
export const LIFT_EVALUATION_STORE = 'liftEvaluations';
export const LIFT_TRUCK_PM_STORE = 'liftTruckPmInspections';
export const JHA_DOCUMENT_TRIGGER_STORE = 'jhaDocumentTriggers';
export const EXT_EQUIPMENT_INSPECTION_STORE = 'extEquipmentInspections';
export const EXT_EQUIPMENT_DAILY_CHECK_STORE = 'extEquipmentDailyChecks';
export const TIMESHEET_RECORD_STORE = 'timesheetRecords';
export const DAILY_JOB_NOTE_STORE = 'dailyJobNotes';
export const SIGNED_TIMESHEET_STORE = 'signedTimesheets';
export const SELECTED_EMPLOYEES_STORE = 'selectedEmployees';
export const SELECTED_JOBS_STORE = 'selectedJobs';
export const SDS_STORE = 'sds';
// Training Sessions (Demo) — synced courses/quizzes + initiator's sessions
export const TRAINING_COURSE_STORE = 'trainingCourses';
export const TRAINING_QUIZ_STORE = 'trainingQuizzes';
export const TRAINING_SESSION_STORE = 'trainingSessions';
export const TRAINING_OUTBOX_STORE = 'trainingOutbox'; // офлайн-очередь мутаций тренинг-сессий
// Safety Scheduling: назначения рэпа по дням + очередь отметок, поставленных офлайн
export const SAFETY_SCHEDULE_STORE = 'safetySchedule';
export const SAFETY_VISIT_OUTBOX_STORE = 'safetyVisitOutbox';
export const URL = TENANT_API_URL;